angular.module('callX').controller('SignUpCtrl', ['$scope', '$state', 'toaster','DataService','UserService','CampaignsService', '$location', '$stateParams', function($scope,$state,toaster,DataService,UserService,CampaignsService, $location, $stateParams) {
    
    // Check if user is authenticated, redirect to new app sign-up
    var baseUrl = window.location.origin;
    var newAppSignUpPath = baseUrl + '/v2/sign-up';
    var searchParams = $location.search();
    var params = Object.keys(searchParams).map(function(key) {
      return key + '=' + encodeURIComponent(searchParams[key]);
    }).join('&');
    if (params) {
        newAppSignUpPath += '?' + params;
    }
    window.location.href = newAppSignUpPath;
    return; // Prevent further controller execution

    $scope.user = {};
    
    $scope.countries = DataService.getCountries();
    // $scope.states = DataService.getProvince();
    $scope.country = {};
    $scope.state = {};
    $scope.timezone = {};
    $scope.countryCodes = DataService.getCountryCodes();
    $scope.signupCodes = DataService.getPublisherSignupCodes();
    $scope.country_code = "1";
    $scope.showConfirmation = false;
    $scope.signupSucess = false;
    $scope.selectAllStates = false;
    $scope.agencyId = null;
    $scope.agencyData = null;

    // Function to fetch agency data by ID
    $scope.getAgencyByAgencyId = function(agencyId) {
        if (!agencyId) return;
        
        var callbacks = {
            success: function(data, status) {
                if (data) {
                    console.log('Agency data loaded:', data);
                    $scope.agencyData = data;
                    toaster.pop('success', 'Agency Found', 'You are signing up through ' + data.name, 3000);
                }
            },
            error: function(data, status) {
                toaster.pop('error', 'Error', 'Failed to fetch agency information', 2000);
            }
        };
        UserService.getAgencyByAgencyId(agencyId, callbacks);
    };

    // Check for agencyId in URL on page load
    var initializeAgencyData = function() {
        var href = window.location.href;
        console.log('Checking URL for agencyId:', href); 
        // Parse URL to get agencyId from hash fragment
        var hash = href.split('#')[1] || '';
        var queryString = hash.split('?')[1] || '';
        var params = new URLSearchParams(queryString);
        var agencyId = params.get('agencyId');
        
        if (agencyId) {
            console.log('Found agencyId in URL:', agencyId);
            $scope.agencyId = agencyId;
            $scope.getAgencyByAgencyId(agencyId);
        }
    };
    
    // Run initialization
    initializeAgencyData();

    // Watch for changes in agency data to update the view
    // $scope.$watch('agencyData', function(newVal) {
    //     if (newVal) {
    //         console.log('Agency data updated:', newVal);
    //     }
    // });

    // Check for agencyId in URL on controller load
    // if ($stateParams.agencyId) {
    //     $scope.agencyId = $stateParams.agencyId;
    //     console.log($scope.agencyId, "get agencyId here")
    //     // Optional: Fetch agency details if needed
    //     // fetchAgencyDetails($scope.agencyId);
    // }

    // var formStateFilteredList = function () {
    //     $scope.stateFilteredList = [];
    //     if (!$scope.country.selected) return;
    //     var selectedCode = $scope.country.selected.code;
    //     for( var i = 0; i < $scope.states.length; i++ ) {
    //         if($scope.states[i].code.indexOf(selectedCode) == 0) {
    //             $scope.stateFilteredList.push($scope.states[i]);
    //         }
    //     }
    // };

    // $scope.getAllCountries = function(){
    //     var callbacks = {
    //         success: function(data) {
    //             $scope.timeZone1 = data.data;
    //         },
    //         failure: function(data) {
    //             toaster.pop('error', 'Error', data.data);
    //         }
    //     };
    //     UserService.getCountries(callbacks);
    // };
    // $scope.getAllCountries();

    // $scope.checkEmail = function () {
    //     $scope.isEmailExists = false;
    //     CampaignsService.checkEmail($scope.user.email)
    //         .success(function (response) {
    //             if(response.title == 'Email found'){
    //                 $scope.isEmailExists = true;
    //                 toaster.pop('error', 'Error', 'Email already exists', 2000);
    //             }
    //         });
    // };
    // console.log($scope.states, "states ---------------------")

    // $scope.$watch(
    //     "country.selected",
    //     function handleFooChange( newValue, oldValue ) {
    //     }
    // );

    // $scope.stepsCompletedAtleastOnce = [0,0];
    // $scope.validationCheck = function () {
    //     $scope.stepOneValidationCompleted = (($scope.user.first_name != undefined) && ($scope.user.last_name != undefined) && ($scope.user.phone_number != undefined) && (!$scope.isEmailExists) && ($scope.user.password != undefined) && ($scope.user.confirmPassword != undefined) && ($scope.user.password == $scope.user.confirmPassword));
    //     // $scope.stepTwoValidationCompleted = (($scope.user.company_website != undefined) && ($scope.user.years_of_experience != undefined) && ($scope.user.is_running_offers != undefined) && ($scope.user.type_of_media != undefined) && ($scope.user.monthly_earnings != undefined));
    // };
    // $scope.validationCheck();

    // $scope.$watch('user', function(newVal, oldVal){
    //     $scope.validationCheck();
    // }, true);

    // $scope.checkTabNavigation = function (step) {
    //     if($scope.stepsCompletedAtleastOnce[0]&&$scope.stepsCompletedAtleastOnce[1]){
    //         if($scope.stepOneValidationCompleted&&$scope.stepTwoValidationCompleted){
    //             $scope.step = step;
    //         }
    //         else{
    //             toaster.pop('error', 'Required Fields',  'Please Fill All The Required Fields', 2000);
    //         }
    //     }
    //     else{
    //         toaster.pop('error', 'Required Fields',  'Please Fill All The Required Fields', 2000);
    //     }
    // };

    // $scope.submitStepOne = function () {
    //     $scope.formOne.$setSubmitted();
    //     toaster.clear();
    //     if ($scope.user.first_name == undefined) {
    //         toaster.pop('error', 'First Name', 'First Name is required', 2000);
    //     }
    //     else if ($scope.user.last_name == undefined) {
    //         toaster.pop('error', 'Last Name', 'Last Name is required', 2000);
    //     }
    //     else if ($scope.user.company_phone_number == undefined) {
    //         toaster.pop('error', 'Phone Number', 'Phone number is required', 2000);
    //     }
    //     else if ($scope.user.email == undefined) {
    //         toaster.pop('error', 'Email', 'Email is required', 2000);
    //     }
    //     else if ($scope.isEmailExists) {
    //         toaster.pop('error', 'Email', 'Email already exists', 2000);
    //     }
    //     else if ($scope.user.password == undefined) {
    //         toaster.pop('error', 'Password', 'Password is required', 2000);
    //     }
    //     else if ($scope.user.password_confirmation == undefined) {
    //         toaster.pop('error', 'Password Confirmation', 'Confirm password is required', 2000);
    //     }
    //     else if (($scope.formOne.password.$dirty)&&(($scope.formOne.password.$error.required)||(!$scope.formOne.password.$valid)) || ($scope.formOne.password_confirmation.$dirty)&&($scope.user.password != $scope.user.password_confirmation)) {
    //         toaster.pop('error', 'Password', 'Password is required', 2000);
    //     }
    //     else if ($scope.timezone.selected == undefined) {
    //         toaster.pop('error', 'Time Zone', 'Time Zone is required', 2000);
    //     }
    //     else if($scope.user.is_agree == undefined) {
    //         toaster.pop('error', 'Terms and Conditions', 'Please accept Terms and Conditions', 2000);
    //     }
    //     else{
    //         $scope.step=2;
    //         $scope.stepsCompletedAtleastOnce[0]=1;
    //         $scope.validationCheck();
    //     }
    // };

    // $scope.submitStepTwo = function () {
    //     $scope.formTwo.$setSubmitted();
    //     toaster.clear();
    //     if($scope.user.company_website == undefined){
    //         toaster.pop('error', 'Website URL', 'Website URL is required.', 2000);
    //     }
    //     else if($scope.user.years_of_experience == undefined){
    //         toaster.pop('error', 'Years of Publisher Experience', 'Years of Publisher Experience is required.', 2000);
    //     }
    //     else if($scope.user.is_running_offers == undefined){
    //         toaster.pop('error', 'Running Pay Per Call Offers?', 'This field is required.', 2000);
    //     }
    //     else if($scope.user.type_of_media == undefined){
    //         toaster.pop('error', 'What Type Of Media Do You Buy?', 'This field is required.', 2000);
    //     }
    //     else if($scope.user.monthly_earnings == undefined){
    //         toaster.pop('error', 'Monthly Earnings', 'Monthly Earnings is required.', 2000);
    //     }
    //     else{
    //         $scope.step=3;
    //         $scope.stepsCompletedAtleastOnce[1]=1;
    //         $scope.validationCheck();
    //     }
    // };

    // $scope.signUp = function() {
    //     $scope.formThree.$setSubmitted();
    //     if(!$scope.stepOneValidationCompleted){
    //         toaster.pop('error', 'Required Fields',  'Please Fill All The Required Fields', 2000);
    //         $scope.step = 1;
    //     }
    //     else if(!$scope.stepTwoValidationCompleted){
    //         toaster.pop('error', 'Required Fields',  'Please Fill All The Required Fields', 2000);
    //         $scope.step = 2;
    //     }
    //     else if ($scope.user.company_name == undefined) {
    //         toaster.pop('error', 'Company Name',  'Company Name is required.', 2000);
    //     }
    //     else if ($scope.user.pay_to == undefined) {
    //         toaster.pop('error', 'Pay To',  'This field is required.', 2000);
    //     }
    //     else if ($scope.user.company_address1 == undefined) {
    //         toaster.pop('error', 'Address Line 1', 'Address Line 1 is required', 2000);
    //     }
    //     else if ($scope.user.company_city == undefined) {
    //         toaster.pop('error', 'Company City', 'Company City is required', 2000);
    //     }
    //     else if ($scope.country.selected == undefined) {
    //         toaster.pop('error', 'Company Country', 'Company Country is required', 2000);
    //     }
    //     else if ($scope.state.selected == undefined) {
    //         toaster.pop('error', 'Company State', 'Company State is required', 2000);
    //     }
    //     else if ($scope.user.company_postal_code == undefined) {
    //         toaster.pop('error', 'Zip Code', 'Zip Code is required', 2000);
    //     }
    //     else if (($scope.formThree.company_postal_code.$dirty)&&($scope.formThree.company_postal_code.$error.pattern)) {
    //         toaster.pop('error', 'Zip Code', 'Zip Code is required', 2000);
    //     }

    //     else {
    //         $scope.user.company_country = $scope.country.selected;
    //         $scope.user.company_state = $scope.state.selected;
    //         $scope.user.utc_zone = $scope.timezone.selected.utc_zone;
    //         $scope.user.time_zone = $scope.timezone.selected.zone_name;
    //         $scope.user.company_phone_number = $scope.country_code + $scope.user.company_phone_number;
    //         $scope.user.is_running_offers = ($scope.user.is_running_offers == 'Yes');
    //         $scope.user.type = 'publisher';
    //         var callbacks = {
    //             success: function (data) {
    //                 if (data.statusCode == 200) {
    //                     $scope.showConfirmation = true;
    //                 }
    //                 else {
    //                     if (data.statusCode == 401) {
    //                         toaster.pop('error', 'Error', data.data);
    //                     }
    //                 }

    //             },
    //             failure: function (data) {
    //                 toaster.pop('error', 'Error', data.data);
    //             }
    //         };
    //         UserService.postCreatePublisher($scope.user, callbacks);
    //     }
    // }; 


    //signup up   
    $scope.regionLicense = [];
    $scope.activeTab = 'account';  
    // $scope.activeTab = 'location'; 
    $scope.progress = 25;

    $scope.changeTab = function(tabName) {
        $scope.activeTab = tabName;
    };

    $scope.redirectToSignIn = function(tabName) {
        var baseUrl = window.location.origin;
        var newAppSignInPath = baseUrl+'/v2/sign-in';  
        if (!baseUrl.includes('localhost')) {
            window.location.href = newAppSignInPath;
        } else {
          $location.path("access/login");
        }   
    };
 
    $scope.showPassword = false;

    $scope.togglePasswordVisibility = function() {
        $scope.showPassword = !$scope.showPassword;
        $scope.showConfirmPassword = !$scope.showConfirmPassword;
    };
    
    $scope.checkSignupZipcode = function() {
        var check_zipcode = $scope.user.zip_code;
        if (check_zipcode && check_zipcode.length === 5 ) { 
            var callbacks = {
                success: function(data) {
                    if (data.data) {
                        $scope.location = data.data;
                        // console.log($scope.location, "location api")
                    } 
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                    $scope.location = {};
                }
            };
            UserService.getStateCity(check_zipcode, callbacks);
        } else {
            $scope.location = {};
        }
    };

    var getUSStates = function() {
        UserService.getUSStates()
            .success(function(response){
                $scope.states = response.data;
                // console.log($scope.states,"from states")
                for (var i = 0; i < $scope.states.length; i++) {
                    var state = $scope.states[i];
                    state.isSelected = false;
                }
            });
    };
    getUSStates();   

    $scope.selectAllStatesFunc = function (val) {
        $scope.selectAllStates = val;
        $scope.regionLicense = [];
        console.log("val", val)
        for (var y = 0; y < $scope.states.length; y++) {
            $scope.states[y].isSelected = $scope.selectAllStates; 

            if ($scope.selectAllStates && !$scope.states[y].license_number) {
                $scope.regionLicense.push({
                    state_code: $scope.states[y].state_code,
                    region_name: $scope.states[y].state_name,
                    license_number: 0
                });
            }
            
        }
        // console.log("select all", $scope.regionLicense)
    }; 

    $scope.showLicense = function(state) {
        // console.log(state, "from specific ---------------");
           for (var i = 0; i <  $scope.states.length; i++){
            if( $scope.states[i].isSelected == true && $scope.states[i].state_code == state.state_code && !$scope.states[i].license_number){
                $scope.regionLicense.push({state_code:$scope.states[i].state_code,region_name:$scope.states[i].state_name,license_number:0});
            }
            else if($scope.states[i].isSelected != true && $scope.states[i].state_code == state.state_code){
                $scope.regionLicense.pop({state_code:$scope.states[i].state_code,region_name:$scope.states[i].state_name,license_number:0});
            }
           }
        }

    var getAgentsRegions = function () {
        var agentsRegions = [];
         if (($scope.user.offer_region == 'specific-states')) {
            for (var i = 0; i < $scope.regionLicense.length; i++ ){ 
                if (typeof $scope.regionLicense[i].license_number !== 'undefined' || $scope.regionLicense[i].license_number === 0) {
                    agentsRegions.push($scope.regionLicense[i]);
                }
            }
          } 
         else if ($scope.user.offer_region == 'all-us'){
            agentsRegions = true;
        }
        console.log(agentsRegions, "from regions")
        return agentsRegions;
    };


//    var getOfferRegions = function () {
//         var offerRegions = [];
//         if (($scope.user.offer_region == 'specific-states')) {
//             for (var i = 0; i < $scope.states.length; i++) {
//                 if ($scope.states[i].isSelected === true) {
//                     offerRegions.push($scope.states[i].state_code);
//                 }
//             }
//         } else if ($scope.user.offer_region == 'all-us'){
//             offerRegions = ['ALL'];
//         }
//         console.log(offerRegions)
//         return offerRegions;
//     };   

    // $scope.validateNumeric = function(event) {
    //     // console.log(event)
    //     var charCode = (event.which) ? event.which : event.keyCode;
    //     if (charCode < 48 || charCode > 57) {
    //         event.preventDefault();
    //     }
    // }; 

    $scope.SignupOneForm = function() {
        if ($scope.user.password !== $scope.user.confirmPassword) {
            toaster.pop('error', 'password' , 'Passwords do not match', 2000);
            return;
        }
        // Check for other required fields
        if (!$scope.user.first_name) {
            toaster.pop('error', 'First Name', 'First Name is required', 2000);
        } else if (!$scope.user.last_name) {
            toaster.pop('error', 'Last Name', 'Last Name is required', 2000);
        }
        // else if (!$scope.user.alias) {
        //     toaster.pop('error', 'alias', 'Alias is required', 2000);
        // } 
        else if (!$scope.user.phone_number) {
            toaster.pop('error', 'Phone Number', 'Phone number is required', 2000);
        } else if (!$scope.user.email) {
            toaster.pop('error', 'Email', 'Please enter a valid email in the correct format, i.e. johndoe@isp.com', 2000);
        } 
        else if (!$scope.user.zip_code) {
            toaster.pop('error', 'Zipcode', 'Zipcode is required', 2000);
        }
        // else if (!$scope.user.password) {
        //     toaster.pop('error', 'Password', 'Password is required', 2000);
        // } else if (!$scope.user.confirmPassword) {
        //     toaster.pop('error', 'Password Confirmation', 'Confirm password is required', 2000);
        // } 
        else {
            // All validations passed, continue with form submission or other actions
            console.log($scope.user, "----------------")
            $scope.changeTab('location');
        }
    };
     

    $scope.selectStates = function(){
        if (!$scope.user.offer_region) {
            toaster.pop('error', 'Error', 'Please select a region', 2000);
            return;
        }
        
        if($scope.user.offer_region === 'specific-states'){
            console.log("specific_states")
            $scope.user.regions_license_dto = getAgentsRegions();
            if (!$scope.user.regions_license_dto || $scope.user.regions_license_dto.length === 0) {
                toaster.pop('error', 'Error', 'Please select at least one region', 2000);
                return;
            }
        }
        else if($scope.user.offer_region === 'all-us'){
            console.log("all-us")
            $scope.user.allusValue = getAgentsRegions();
        }
       
            $scope.changeTab('amountBid') 
    }

    function generatePassword() {
        var length = 6;
        var lowercase = 'abcdefghijklmnopqrstuvwxyz';
        var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var digits = '0123456789';
        var specialChars = '@$!%*?&';

        var password = '';
        password += lowercase[Math.floor(Math.random() * lowercase.length)];
        password += uppercase[Math.floor(Math.random() * uppercase.length)];
        password += digits[Math.floor(Math.random() * digits.length)];
        password += specialChars[Math.floor(Math.random() * specialChars.length)];

        var charset = lowercase + uppercase + digits + specialChars;
        for (var i = password.length; i < length; i++) {
            password += charset[Math.floor(Math.random() * charset.length)];
        }

        // Shuffle the password
        return password.split('').sort(function() {
            return 0.5 - Math.random();
        }).join('');
    }

    function convertToCamelCaseArray(dataArray) {
        if (!angular.isArray(dataArray)) return dataArray;
    
        var keyMap = {
            "state_code": "stateCode",
            "region_name": "regionName",
            "license_number": "licenseNumber"
        };
    
        var newArray = [];
        for (var i = 0; i < dataArray.length; i++) {
            var obj = dataArray[i];
            var newObj = {};
    
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    var newKey = keyMap[key] || key; // Use mapped key or fallback to original
                    newObj[newKey] = obj[key];
                }
            }
            newArray.push(newObj);
        }
        return newArray;
    }

    $scope.fetchAgentTimeZones = function(){
        var callbacks = {
            success: function(data) {
                $scope.allTimeZones = data.data;
            },
            failure: function(data) {
            }
        };
        UserService.getAgentTimeZones(callbacks);
    };
    $scope.fetchAgentTimeZones();

    $scope.BillForm = function() {
        // console.log("success")
        if (!$scope.user.bid_amount || $scope.user.bid_amount < 65) {
            toaster.pop('error', 'Error', 'Please enter bid amount of $65 or more', 2000);
            return; 
        }
        // console.log($scope.user, "get user object") 
        $scope.user.status = "pending";

        var postdata = {
            firstName:$scope.user.first_name,
            lastName:$scope.user.last_name,
            phoneNumber:$scope.user.phone_number,
            alias: ($scope.user.first_name.trim() + '_' + $scope.user.last_name.trim()).replace(/\s+/g, ''),
            email:$scope.user.email,
            password: generatePassword(),
            zipCode:$scope.user.zip_code,
            // regions_license_dto:$scope.user.regions_license_dto,
            // all_us:$scope.user.allusValue,
            // status:$scope.user.status,
            bidAmount:$scope.user.bid_amount,
            agencyId: $scope.agencyId ? $scope.agencyId: null,
            managerId: null,
            status: "pending",
            state: $scope.user.timezone,
            roles: ["AGENT"]
        }

        if ($scope.user.offer_region == 'specific-states') {
            postdata.regionsLicenseDto = convertToCamelCaseArray($scope.user.regions_license_dto)
            postdata.allUs = false;
        } else {
            postdata.allUs = true;
        }

        console.log(postdata, "post request")
        
        var callbacks = {
            success: function(data, status) {
                    if(status == 200) {
                        $scope.signupSucess = true;
                        toaster.pop('success', 'Success', 'Agent successfully created', 2000);
                        $scope.tableContentLoading = false;
                    } 
                    else {
                        toaster.pop('error', 'Error', data, 2000);
                    }
                    },
                    error: function(data) {
                        toaster.pop('error', 'Error', data, 2000);
                        $scope.tableContentLoading = false;
                    }
                };
                UserService.signupAgent(postdata,callbacks); 
        }
    
  }]);